import { sessionStorageUtil } from "../utils/storage";

export const saveCustomPortfolio = async (email, folioNo, data) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();

  const { title, description, funds } = data;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/custom-unitholder-portfolio`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        amc_code: amcCode,
        folio_no: folioNo,
        fund_codes: funds,
        title,
        description,
      }),
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message || "Get custom portfolio - failed");
    }

    return {
      data,
      error: false,
      message: data.message || "GET custom portfolio - success",
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error.message,
    };
  }
};

export const updateCustomPortfolio = async (email, folioNo, id, data) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();

  const { title, description, funds } = data;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/custom-unitholder-portfolio`, {
      method: "PUT",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        custom_unitholder_portfolio_id: id,
        amc_code: amcCode,
        folio_no: folioNo,
        fund_codes: funds,
        title,
        description,
      }),
    });

    const data = await response.json();

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message || "Get custom portfolio - failed");
    }

    // console.log(data);

    return {
      data,
      error: false,
      message: data.message || "GET custom portfolio - success",
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error.message,
    };
  }
};

export const deleteCustomPortfolio = async (email, folioNo, id) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/custom-unitholder-portfolio/status`, {
      method: "PUT",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        custom_unitholder_portfolio_id: id,
        amc_code: amcCode,
        folio_no: folioNo,
        status: false,
      }),
    });

    const data = await response.json();

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message || "Error deleting custom portfolio");
    }

    // console.log(data);

    return {
      error: false,
      message: data.message || "Successfully deleted custom portfolio",
    };
  } catch (error) {
    // console.log(error);

    return {
      error: true,
      message: error.message,
    };
  }
};

export const getCustomPortfolio = async (data) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();

  const { email, folio_no, title } = data;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/custom-unitholder-portfolio?amc_code=${encodeURIComponent(amcCode)}&email=${encodeURIComponent(email)}&folio_no=${encodeURIComponent(folio_no)}&status=true`,
      {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.json();

    if ((!response.ok || data?.status !== 200) && data?.status !== 404) {
      throw new Error(data?.message || "Get custom portfolio - failed");
    }

    return {
      data: data?.data,
      error: false,
      message: data.message || "GET custom portfolio - success",
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error.message,
    };
  }
};

export const getUnitholderStatement = async (data) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();

  const { email, folio_no, from, to, fundCode } = data;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/report/unitholder-statement?email=${email}&amc_code=${amcCode}&folio_no=${folio_no}&from_date=${from}&to_date=${to}${fundCode ? `&fund_code=${fundCode}` : ''}`,
      {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.json();

    if ((!response.ok || data?.status !== 200) && data?.status !== 404) {
      throw new Error(data?.message || "Get Unitholder Statement - failed");
    }

    return {
      data: data?.data,
      error: false,
      message: data.message || "GET Unitholder Statement - success",
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error.message,
    };
  }
}

export const getCgtTax = async (data) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();
  const email = process.env.REACT_APP_API_GUEST_EMAIL;

  const {
    fundCode,
    fundUnits,
    folioNumber,
    redemptionDate
  } = data;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/investor-app/transactions/cgt/calculate?email=${email}&amc_code=${amcCode}&fund_code=${fundCode}&fund_units=${fundUnits}&folio_number=${folioNumber}&redemption_date=${redemptionDate}`,
      {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.json();

    if ((!response.ok || data?.status !== 200) && data?.status !== 404) {
      throw new Error(data?.message || "Get CGT Tax - failed");
    }

    return {
      data: data?.data,
      error: false,
      message: data.message || "GET CGT Tax - success",
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error.message,
    };
  }
}